import { useSearchFilters } from "../use-search-filters";
import { useSearchFiltersFormatting } from "../use-search-filters-formatting";
export const MAX_FILTER_INDEX_TO_SHOW = 4;
export const useSearchAlertFiltersFormatting = ()=>{
    const { formatFilterPill  } = useSearchFiltersFormatting();
    const { filters  } = useSearchFilters();
    const getFlattenedFilters = ()=>Object.entries(filters).flatMap(([key, values])=>{
            const filterKey = key;
            return values.map((value, index)=>({
                    key: `${key}-${index}`,
                    value,
                    display: formatFilterPill(filterKey, value)
                }));
        });
    const transformExtraFilter = (filterItem, index, filters)=>{
        if (index === MAX_FILTER_INDEX_TO_SHOW && filters.length > MAX_FILTER_INDEX_TO_SHOW + 1) {
            return {
                key: "extras",
                value: "extras",
                display: `+ ${filters.length - MAX_FILTER_INDEX_TO_SHOW} more filters`
            };
        }
        return filterItem;
    };
    return getFlattenedFilters().map((element, index, array)=>transformExtraFilter(element, index, array)).slice(0, MAX_FILTER_INDEX_TO_SHOW + 1);
};
